import React, { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { injectIntl } from 'react-intl';

import MobileSettingsForm from '../../../components/SiteAdmin/MobileSettingsForm/MobileSettingsForm';
import Loader from '../../../components/Common/Loader/Loader';

import getSiteSettings from './getSiteSettings.graphql';
import useQueryResponse from '../../../lib/hooks/useQueryResponse';
import { decode, censorWord } from '../../../helpers/queryEncryption';
import { salesUser } from '../../../helpers/demoRestriction/demo';

const MobileSettings = ({ adminId, isDemoRestricted }) => {

  const { loading, data, refetch } = useQueryResponse({
    query: getSiteSettings,
    variables: { type: 'appSettings' },
    fetchPolicy: 'network-only',
  });

  const mobileSettingsCollection = useMemo(() => {
    const results = data?.getSiteSettings?.results || [];
    return results.reduce((acc, { name, encryptValue }) => {
      if (['userAppAndroidMapAPIKey', 'serviceProviderAppAndroidMapAPIKey', 'userAppIosMapAPIKey', 'serviceProviderAppIosMapAPIKey'].includes(name)) {
        acc[name] = (isDemoRestricted == 'true' && salesUser.indexOf(adminId) < 0) ? censorWord(decode(encryptValue)) : decode(encryptValue)
      } else {
        acc[name] = decode(encryptValue)
      };
      acc['isRestrict'] = isDemoRestricted == 'true' && salesUser.indexOf(adminId) < 0;
      return acc;
    }, {});
  }, [data]);

  return (
    <Loader type="page" show={loading}>
      {!loading && (
        <MobileSettingsForm
          refetch={refetch}
          getSiteSettings={data?.getSiteSettings}
          initialValues={mobileSettingsCollection}
        />
      )}
    </Loader>
  );
};

export default injectIntl(MobileSettings);